export function getWindow(): Window {
  return window
}

export const getLocationPathname = () => getWindow().location.pathname

export const getFirstRouteElementFromPathname = (pathname: string): string => {
  const paths = pathname.toLowerCase().split('/')
  return paths[1] ?? ''
}
